define('features/overlayGameLauncher/overlayGame2',[
    'jquery',
    'knockout',
    'underscore'
], function ($, ko, _) {

    function setTestingState () {}

    return function overlayGame2 (
        navigation,
        statViewModels) {

        var self = this,
            currentlyActiveScreenName = ko.observable();

        /**
         * CSS binding functionality for the stat view models. Moved this
         * functionality in the view model to try and keep the view markup as
         * clean as possible.
         */
        self.cssBindingFor = _.memoize(function (vm) {
            return ko.pureComputed(function () {
                var css = {
                    'active': self.activeScreen.equals(vm)
                };

                _.set(css, vm.id, true);

                return css;
            });
        });

        self.statViewModels = statViewModels.pipe(function (injectedStatViewModels) {
            return _.map(injectedStatViewModels, function (StatViewModel) {
                return new StatViewModel(self);
            });
        });

        self.changeCurrentScreenTo = function (statViewModel) {
            currentlyActiveScreenName(_.isNil(statViewModel) ? null : statViewModel.id);
        };

        self.changeCurrentScreenToById = function (statViewModelId) {
            self.changeCurrentScreenTo(_.find(self.statViewModels(), {
                id: statViewModelId
            }));
        };

        self.changeToNoScreen = function () {
            self.changeCurrentScreenTo(null);
        };

        self.activeScreen = ko.pureComputed(function () {
            return _.find(self.statViewModels(), {
                id: currentlyActiveScreenName()
            });
        });

        self.isScreenActive = ko.pureComputed(function () {
            return !!self.activeScreen();
        });

        self.src = ko.observable();
        self.launch = function (gameModel) {
            navigation.navigate(navigation.ROUTES.OVERLAY_GAME_2);
            self.src(gameModel.gameUrl);
        };

        self.activate = function () {
            $('.top-bar').hide();
            $('.pages').css('padding-top', 0);
        };

        self.deactivate = function () {
            $('.top-bar').show();
            $('.pages').css('padding-top', '');
        };

        self.compositionComplete = setTestingState.bind(self);
    };
});

